/// we share this functions bewtween delphi and nodejs processes

export type TFSDirTreeItem = {
  fullPath: string;
  filePath: string;
  isDirectory: boolean;
  size: number;
  dateModified?: string;
};
export const sysSeparator = process.env.REACT_APP_MODE === "REACT" ? "/" : "\\";

export function transformData(fetchedData) {
  return fetchedData.reduce((acc, file: TFSDirTreeItem, index) => {
    const [cif, invoiceSerial, fileName] = file.filePath.split(sysSeparator);
    if (!invoiceSerial) {
      return acc;
    }
    // Ensure the CIF and invoiceSerial structure is properly initialized
    if (!acc[cif]) acc[cif] = {};
    if (!acc[cif][invoiceSerial]) acc[cif][invoiceSerial] = [];
    // Add the file to the appropriate place in the structure
    acc[cif][invoiceSerial].push({
      ...file,
      fileName, // Optionally include fileName for convenience
    });
    return acc;
  }, {});
}

export function isItemOk(
  result: any
): result is { value: { items: TFSDirTreeItem[] } } {
  return result && result.value && Array.isArray(result.value.items);
}
